import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Container } from '@fiverr-private/layout_components';
import { useCarouselContext } from '../Carousel/constants';
import { useTrackContext } from '../Track/constants';
import { showHalfCardStyles } from '../styles.ve.css';
import type { SlideProps } from './types';
import { SLIDE_ID } from './constants';
import { getMinWidth } from './utils';

const Slide = ({ className, children }: SlideProps) => {
  const { breakpoints, setNumOfMountedSlides } = useCarouselContext();
  const { slidesGap, autoSlidesWidth, showSwipeHalfCard } = useTrackContext();

  useEffect(() => {
    setNumOfMountedSlides?.((prevState) => ++prevState);
  }, [setNumOfMountedSlides]);

  return (
    <Container
      minWidth={autoSlidesWidth ? 'fit-content' : getMinWidth(breakpoints, slidesGap)}
      style={{ scrollSnapAlign: 'start' }}
      className={classNames({ [showHalfCardStyles]: showSwipeHalfCard }, className)}
    >
      {children}
    </Container>
  );
};

Slide.id = SLIDE_ID;
Slide.displayName = SLIDE_ID;
export default Slide;
